const STORAGE_KEY = 'favorites';
export const FAVORITES_STORAGE_KEY = STORAGE_KEY;
export const FAVORITES_UPDATED_EVENT = 'favoritesUpdated';

const parseNumber = (value) => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === 'string') {
        const normalized = value.replace(/\s+/g, '').replace(',', '.');
        const parsed = Number(normalized);
        if (Number.isFinite(parsed)) {
            return parsed;
        }
    }
    return undefined;
};

export const readFavoritesFromStorage = () => {
    if (typeof window === 'undefined') {
        return [];
    }
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return [];
        }
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.filter((item) => item && typeof item === 'object' && item.id);
    } catch (error) {
        console.error('[favorites] failed to parse favorites storage', error);
        return [];
    }
};

export const writeFavoritesToStorage = (items) => {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        const payload = Array.isArray(items) ? items : [];
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
        console.error('[favorites] failed to write favorites storage', error);
    }
    window.dispatchEvent(new Event(FAVORITES_UPDATED_EVENT));
};

const firstNonEmptyString = (...values) => {
    for (const value of values) {
        if (typeof value === 'string' && value.trim()) {
            return value.trim();
        }
    }
    return undefined;
};

const firstTruthy = (...values) => {
    for (const value of values) {
        if (value !== undefined && value !== null && String(value).trim() !== '') {
            return value;
        }
    }
    return undefined;
};

export const extractFavoriteData = (product, overrides = {}) => {
    if (!product && !overrides) {
        return null;
    }

    const idCandidate = firstTruthy(
        overrides.id,
        product?.favoriteId,
        product?.id,
        product?.code,
        product?.product_id,
        product?.productId,
        product?.elastic_document?.core?.sku,
        product?.elastic_document?.core?.id,
    );

    if (!idCandidate) {
        return null;
    }

    const id = String(idCandidate);

    const picture = firstNonEmptyString(
        overrides.picture,
        product?.picture,
        product?.image,
        product?.preview_picture,
        product?.previewPicture,
        product?.detail_picture,
        product?.detailPicture,
        Array.isArray(product?.image_gallery) ? product.image_gallery[0] : undefined,
    ) || '/placeholder.png';

    const codeCandidate = firstNonEmptyString(
        overrides.code,
        product?.code,
        product?.slug,
        product?.elastic_document?.core?.slug,
        product?.product_code,
        id,
    );

    const nameCandidate = firstNonEmptyString(
        overrides.name,
        product?.name,
        product?.title,
        product?.product_name,
        product?.elastic_document?.core?.name,
        'Товар',
    );

    const price = parseNumber(overrides.price ?? product?.price ?? product?.current_price ?? product?.elastic_document?.pricing?.price ?? product?.elastic_document?.core?.price);
    const priceOld = parseNumber(overrides.priceOld ?? product?.priceOld ?? product?.old_price ?? product?.elastic_document?.pricing?.price_old ?? product?.elastic_document?.core?.price_old);

    return {
        id,
        code: codeCandidate || id,
        name: nameCandidate || 'Товар',
        picture,
        price,
        priceOld,
    };
};

export const removeFavoriteById = (favoriteId) => {
    if (!favoriteId) {
        return;
    }
    const current = readFavoritesFromStorage();
    const next = current.filter((item) => item.id !== favoriteId);
    writeFavoritesToStorage(next);
};
